import styled from 'styled-components'

import { FlowBottomArea, FlowTitle } from '../../styles'

export const StyledFlowTechnicalIssues = {
  Title: styled(FlowTitle)`
    margin-bottom: 24px;
  `,
  Content: styled.div`
    padding-bottom: 144px;
  `,
  BottomArea: styled(FlowBottomArea)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 8px;
  `,
}
